import { render, staticRenderFns } from "./TermOption.vue?vue&type=template&id=a0dcdd2a"
import script from "./TermOption.vue?vue&type=script&lang=js"
export * from "./TermOption.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a0dcdd2a')) {
      api.createRecord('a0dcdd2a', component.options)
    } else {
      api.reload('a0dcdd2a', component.options)
    }
    module.hot.accept("./TermOption.vue?vue&type=template&id=a0dcdd2a", function () {
      api.rerender('a0dcdd2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/register/TermOption.vue"
export default component.exports